import React, { useState, useEffect } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Config from '../../config/env';
import API from '../../utils/apiCalling';
import Loader from '../../utils/loader';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const JourneysGeneral = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [generaldashboardData, setGeneralDashboardData] = useState([]);
  const [jouurneydashboardData, setJourneyDashboardData] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [surveyId, setSurveyId] = useState(null);
  const checkarray = ['Select RESPONDENT TYPE','Enter your details.','PROCESS TYPE','RESPONDENT TYPE']
  const id = useParams();

  let api = new API();

  useEffect(() => {
   
    getSurveyById("67b03d9024f7d3ec70fa1661")
  
  }, []);

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate); // Update state with the new selected date
    // getDashBoard(id, newDate); 
    getgeneralDashBoard(newDate)// Fetch data based on the selected date
    getJourneyDashBoard(newDate)
};


const getgeneralDashBoard = async (cutoffDate) => {
   
      try {
          setLoader(true);
  
          // Prepare the API request payload
          let data
          if(id?.id=="Kadence"){
          data = { surveyId: "67d024001af98385839c2535" };
          }else if(id?.id=="Maction"){
            data = { surveyId: "67b03d9024f7d3ec70fa1661" };
          }
          // Make the API call
          const surveyData = await api.post(`${Config.new.site_api}/client-survey/Dashboard`, data);
          
          console.log('API General Response:', surveyData);
          // Validate the API response
          if (surveyData?.code === 200 && Array.isArray(surveyData.data)) {
              const cutoffDateObj = new Date(cutoffDate); // Convert selected date to Date object
  
              // Filter objects based on the date
              const filteredData = surveyData.data.filter((item) => {
                  if (item?.date) {
                      const itemDate = new Date(item.date);
                      if (!isNaN(itemDate)) {
                          return itemDate > cutoffDateObj;
                      } else {
                          console.warn(`Invalid date format for item:`, item);
                          return false;
                      }
                  } else {
                      console.warn(`Missing date field in item:`, item);
                      return false;
                  }
              });
  
              console.log('API General Filtered Response:', filteredData);
             setGeneralDashboardData(filteredData)
          } else {
              console.error('Unexpected response structure or error in API:', surveyData);
          }
      } catch (error) {
          console.error('Error in getDashBoard:', error);
      } finally {
          setLoader(false);
      }
  };

  const getJourneyDashBoard = async (cutoffDate) => {
   
    try {
        setLoader(true);

        // Prepare the API request payload
        // const data = { surveyId: "67aee648be47182c31b806ee" };

        let datajourney
        if(id?.id=="Kadence"){
          datajourney = { surveyId: "67d023ed1af98385839c2507" };
        }else if(id?.id=="Maction"){
          datajourney = { surveyId: "67aee648be47182c31b806ee" };
        }
        // Make the API call
        const surveyData = await api.post(`${Config.new.site_api}/client-survey/Dashboard`, datajourney);
        // console.log('API Journey Response:', surveyData);

        // Validate the API response
        if (surveyData?.code === 200 && Array.isArray(surveyData.data)) {
            const cutoffDateObj = new Date(cutoffDate); // Convert selected date to Date object

            // Filter objects based on the date
            const filteredData = surveyData.data.filter((item) => {
                if (item?.date) {
                    const itemDate = new Date(item.date);
                    if (!isNaN(itemDate)) {
                        return itemDate > cutoffDateObj;
                    } else {
                        console.warn(`Invalid date format for item:`, item);
                        return false;
                    }
                } else {
                    console.warn(`Missing date field in item:`, item);
                    return false;
                }
            });

            // console.log('Filtered Journey Data:', filteredData);
           setJourneyDashboardData(filteredData)
        } else {
            console.error('Unexpected response structure or error in API:', surveyData);
        }
    } catch (error) {
        console.error('Error in getDashBoard:', error);
    } finally {
        setLoader(false);
    }
};

  const getSurveyById = async (id) => {
    let data = { id: id };
    let result = await api.post(`${Config.new.site_api}/client-survey/getSurvey`, data);

    console.log(result.data)
    if (result && result.code === 200) {
      const questionsWithState = result.data.questions.map(q => ({ ...q, isOpen: false }));
      console.log(questionsWithState)
      setAllQuestions(questionsWithState);
    }
  };


  // Helper function to check if the question is in the checkarray
  const isQuestionInCheckArray = (question) => {
    
    return checkarray.includes(question);
  };


  const handleDownloadRupay = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    worksheet.getColumn(1).width = 13;
    worksheet.getColumn(2).width = 23;
    worksheet.getColumn(3).width = 13;
    worksheet.getColumn(4).width = 13;
    worksheet.getColumn(5).width = 13;
    worksheet.getColumn(6).width = 13
    worksheet.getColumn(7).width = 13;
    worksheet.getColumn(8).width = 13;
    worksheet.getColumn(9).width = 13;
    worksheet.getColumn(10).width = 13;
    worksheet.getColumn(11).width = 13;
    worksheet.getColumn(12).width = 13;
    worksheet.getColumn(13).width = 13;
    worksheet.getColumn(14).width = 13;
    worksheet.getColumn(15).width = 13;
    worksheet.getColumn(16).width = 13;
    worksheet.getColumn(17).width = 13;
    worksheet.getColumn(18).width = 13;
    worksheet.getColumn(19).width = 13;
    worksheet.getColumn(20).width = 13;
    worksheet.getColumn(21).width = 13;
    worksheet.getColumn(22).width = 13;
    worksheet.getColumn(23).width = 13;

    // Merge cells for headers
   
    worksheet.mergeCells('B2:B2');
    worksheet.mergeCells('B3:B3');
    worksheet.mergeCells('B4:B4');
    worksheet.mergeCells('B5:B5');
    worksheet.mergeCells('B6:B6');
    worksheet.mergeCells('B7:B7');
    worksheet.mergeCells('B8:B8');
    worksheet.mergeCells('B9:B9');
    worksheet.mergeCells('B10:B10');

    worksheet.mergeCells('B13:B13');
    worksheet.mergeCells('B14:B14');
    worksheet.mergeCells('B15:B15');
    worksheet.mergeCells('B16:B16');
    worksheet.mergeCells('B17:B17');
    worksheet.mergeCells('B18:B18');
    worksheet.mergeCells('B19:B19');
    worksheet.mergeCells('B20:B20');
    worksheet.mergeCells('B21:B21');
    worksheet.mergeCells('B22:B22');
    worksheet.mergeCells('B23:B23');
    worksheet.mergeCells('B26:B26');
   


    worksheet.mergeCells('C2:E2');
    worksheet.mergeCells('C3:C3');
    worksheet.mergeCells('C4:C4');
    worksheet.mergeCells('C5:C5');
    worksheet.mergeCells('C6:C6');
    worksheet.mergeCells('C7:C7');
    worksheet.mergeCells('C8:C8');
    worksheet.mergeCells('C9:C9');
    worksheet.mergeCells('C10:C10');

    worksheet.mergeCells('C13:E13');
    worksheet.mergeCells('C14:C14');
    worksheet.mergeCells('C15:C15');
    worksheet.mergeCells('C16:C16');
    worksheet.mergeCells('C17:C17');
    worksheet.mergeCells('C18:C18');
    worksheet.mergeCells('C19:C19');
    worksheet.mergeCells('C20:C20');
    worksheet.mergeCells('C21:C21');
    worksheet.mergeCells('C22:C22');
    worksheet.mergeCells('C23:C23');
    worksheet.mergeCells('C26:C26');
   


    // worksheet.mergeCells('D2:D2');
    worksheet.mergeCells('D3:D3');
    worksheet.mergeCells('D4:D4');
    worksheet.mergeCells('D5:D5');
    worksheet.mergeCells('D6:D6');
    worksheet.mergeCells('D7:D7');
    worksheet.mergeCells('D8:D8');
    worksheet.mergeCells('D9:D9');
    worksheet.mergeCells('D10:D10');

    // worksheet.mergeCells('D13:D13');
    worksheet.mergeCells('D14:D14');
    worksheet.mergeCells('D15:D15');
    worksheet.mergeCells('D16:D16');
    worksheet.mergeCells('D17:D17');
    worksheet.mergeCells('D18:D18');
    worksheet.mergeCells('D19:D19');
    worksheet.mergeCells('D20:D20');
    worksheet.mergeCells('D21:D21');
    worksheet.mergeCells('D22:D22');
    worksheet.mergeCells('D23:D23');
    worksheet.mergeCells('D26:D26');
   

    // worksheet.mergeCells('E2:E2');
    worksheet.mergeCells('E3:E3');
    worksheet.mergeCells('E4:E4');
    worksheet.mergeCells('E5:E5');
    worksheet.mergeCells('E6:E6');
    worksheet.mergeCells('E7:E7');
    worksheet.mergeCells('E8:E8');
    worksheet.mergeCells('E9:E9');
    worksheet.mergeCells('E10:E10');

    // worksheet.mergeCells('E13:E13');
    worksheet.mergeCells('E14:E14');
    worksheet.mergeCells('E15:E15');
    worksheet.mergeCells('E16:E16');
    worksheet.mergeCells('E17:E17');
    worksheet.mergeCells('E18:E18');
    worksheet.mergeCells('E19:E19');
    worksheet.mergeCells('E20:E20');
    worksheet.mergeCells('E21:E21');
    worksheet.mergeCells('E22:E22');
    worksheet.mergeCells('E23:E23');
    worksheet.mergeCells('E26:E26');
    

    worksheet.mergeCells('F2:H2');
    worksheet.mergeCells('F3:F3');
    worksheet.mergeCells('F4:F4');
    worksheet.mergeCells('F5:F5');
    worksheet.mergeCells('F6:F6');
    worksheet.mergeCells('F7:F7'); 
    worksheet.mergeCells('F8:F8');
    worksheet.mergeCells('F9:F9');
    worksheet.mergeCells('F10:F10');

    worksheet.mergeCells('F13:H13');
    worksheet.mergeCells('F14:F14');
    worksheet.mergeCells('F15:F15');
    worksheet.mergeCells('F16:F16');
    worksheet.mergeCells('F17:F17');
    worksheet.mergeCells('F18:F18');
    worksheet.mergeCells('F19:F19');
    worksheet.mergeCells('F20:F20');
    worksheet.mergeCells('F21:F21');
    worksheet.mergeCells('F22:F22');
    worksheet.mergeCells('F23:F23');
    worksheet.mergeCells('F26:F26');
   

    // worksheet.mergeCells('G2:G2');
    worksheet.mergeCells('G3:G3');
    worksheet.mergeCells('G4:G4');
    worksheet.mergeCells('G5:G5');
    worksheet.mergeCells('G6:G6');
    worksheet.mergeCells('G7:G7');
    worksheet.mergeCells('G8:G8');
    worksheet.mergeCells('G9:G9');
    worksheet.mergeCells('G10:G10');

    // worksheet.mergeCells('G13:G13');
    worksheet.mergeCells('G14:G14');
    worksheet.mergeCells('G15:G15');
    worksheet.mergeCells('G16:G16');
    worksheet.mergeCells('G17:G17');
    worksheet.mergeCells('G18:G18');
    worksheet.mergeCells('G19:G19');
    worksheet.mergeCells('G20:G20');
    worksheet.mergeCells('G21:G21');
    worksheet.mergeCells('G22:G22');
    worksheet.mergeCells('G23:G23');
    worksheet.mergeCells('G26:G26');
   

    // worksheet.mergeCells('H2:H2');
    worksheet.mergeCells('H3:H3');
    worksheet.mergeCells('H4:H4');
    worksheet.mergeCells('H5:H5');
    worksheet.mergeCells('H6:H6');
    worksheet.mergeCells('H7:H7');
    worksheet.mergeCells('H8:H8');
    worksheet.mergeCells('H9:H9');
    worksheet.mergeCells('H10:H10');

    // worksheet.mergeCells('H13:H13');
    worksheet.mergeCells('H14:H14');
    worksheet.mergeCells('H15:H15');
    worksheet.mergeCells('H16:H16');
    worksheet.mergeCells('H17:H17');
    worksheet.mergeCells('H18:H18');
    worksheet.mergeCells('H19:H19');
    worksheet.mergeCells('H20:H20');
    worksheet.mergeCells('H21:H21');
    worksheet.mergeCells('H22:H22');
    worksheet.mergeCells('H23:H23');
    worksheet.mergeCells('H26:H26');
  

    worksheet.mergeCells('I2:K2');
    worksheet.mergeCells('I3:I3');
    worksheet.mergeCells('I4:I4');
    worksheet.mergeCells('I5:I5');
    worksheet.mergeCells('I6:I6');
    worksheet.mergeCells('I7:I7');
    worksheet.mergeCells('I8:I8');
    worksheet.mergeCells('I9:I9');
    worksheet.mergeCells('I10:I10');

    worksheet.mergeCells('I13:K13');
    worksheet.mergeCells('I14:I14');
    worksheet.mergeCells('I15:I15');
    worksheet.mergeCells('I16:I16');
    worksheet.mergeCells('I17:I17');
    worksheet.mergeCells('I18:I18');
    worksheet.mergeCells('I19:I19');
    worksheet.mergeCells('I20:I20');
    worksheet.mergeCells('I21:I21');
    worksheet.mergeCells('I22:I22');
    worksheet.mergeCells('I23:I23');
    worksheet.mergeCells('I26:I26');
  
   
    // Define styles
    const headerStyle = {
      font: { bold: true, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fffed9' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };

    const plannedstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bdd3f9' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const cellStyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const SpecialStyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e3e3e3' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const plannedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedstyle = {
      font: { color: { argb: '00000000' }, size: 12, },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '92c67c' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingtyle = {
      font: { color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffcc98' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };


    // Define cell values and styles for column B
    const cellsToStyleB = [
      { cell: 'B2', value: 'General Survey -' },
      { cell: 'B3', value: 'Location' },
      { cell: 'B4', value: 'Approach' },
      { cell: 'B5', value: 'Commercial' },
      { cell: 'B6', value: 'Residential' },
      { cell: 'B7', value: 'LTMD' },
      { cell: 'B8', value: 'Agriculture' },
      { cell: 'B9', value: 'HT' },
      { cell: 'B10', value: 'Total' },

      { cell: 'B13', value: 'Journey Wise Survey -' },
      { cell: 'B14', value: 'Location' },
      { cell: 'B15', value: 'Approach' },
      { cell: 'B16', value: 'Digital Interaction' },
      { cell: 'B17', value: 'All Application' },
      { cell: 'B18', value: 'Billing Complaints' },
      { cell: 'B19', value: 'All Other Complaints' },
      { cell: 'B20', value: 'Call center Interactions' },
      { cell: 'B21', value: 'Service Center Visits' },
      { cell: 'B22', value: 'KAM(HT)' },
      { cell: 'B23', value: 'Total' },

      { cell: 'B26', value: 'Overall Total' },
   
    
    

    ];

    cellsToStyleB.forEach(({ cell, value }) => {


      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      let cellkivalue = ['General Survey -','Location','Journey Wise Survey -','Ahmedabad & Gandhinagar','Surat','Overall Total']
      if (cellkivalue.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.font = cellStyle.font;
        excelCell.alignment = cellStyle.alignment;
        excelCell.border = cellStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });


    // Define cell values and styles for new headers
    if(id?.id=="Maction"){
    const cellsToStyleNew = [
        { cell: 'C2', value: 'Ahmedabad & Gandhinagar' },
      { cell: 'C3', value: 'Planned' },
      { cell: 'C4', value: 'CAPI' },
      { cell: 'C13', value: 'Ahmedabad & Gandhinagar' },
      { cell: 'C14', value: 'Planned' },
      { cell: 'C15', value: 'CAPI' },
      { cell: 'D3', value: 'Achieved' },
      { cell: 'D4', value: 'CAPI' },
      { cell: 'D14', value: 'Achieved' },
      { cell: 'D15', value: 'CAPI' },
      { cell: 'E3', value: 'Pending' },
      { cell: 'E4', value: 'CAPI' },
      { cell: 'E14', value: 'Pending' },
      { cell: 'E15', value: 'CAPI' },
      { cell: 'F2', value: 'Surat' },
      { cell: 'F3', value: 'Planned' },
      { cell: 'F4', value: 'CAPI' },
      { cell: 'F13', value: 'Surat' },
      { cell: 'F14', value: 'Planned' },
      { cell: 'F15', value: 'CAPI' },
      { cell: 'G3', value: 'Achieved' },
      { cell: 'G4', value: 'CAPI' },
      { cell: 'G14', value: 'Achieved' },
      { cell: 'G15', value: 'CAPI' },
      { cell: 'H3', value: 'Pending' },
      { cell: 'H4', value: 'CAPI' },
      { cell: 'H14', value: 'Pending' },
      { cell: 'H15', value: 'CAPI' },
      { cell: 'I2', value: 'Total' },
      { cell: 'I3', value: 'Planned' },
      { cell: 'I4', value: 'CAPI' },
      { cell: 'I13', value: 'Total' },
      { cell: 'I14', value: 'Planned' },
      { cell: 'I15', value: 'CAPI' },
      { cell: 'J3', value: 'Achieved' },
      { cell: 'J4', value: 'CAPI' },
      { cell: 'J14', value: 'Achieved' },
      { cell: 'J15', value: 'CAPI' },
      { cell: 'K3', value: 'Pending' },
      { cell: 'K4', value: 'CAPI' },
      { cell: 'K14', value: 'Pending' },
      { cell: 'K15', value: 'CAPI' },
     
      
       ];
    let data2 = ['Ahmedabad & Gandhinagar','Surat','Total']
    cellsToStyleNew.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (data2.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = SpecialStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }else if (value == 'Achieved') {
        excelCell.font = headerStyle.font;
        excelCell.fill = achievedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Pending') {
        excelCell.font = headerStyle.font;
        excelCell.fill = pendingtyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = headerStyle.fill;
        excelCell.font = headerStyle.font;
      }

    });
  }
  if(id?.id=="Kadence"){
    const cellsToStyleNew = [
        { cell: 'C2', value: 'Ahmedabad & Gandhinagar' },
      { cell: 'C3', value: 'Planned' },
      { cell: 'C4', value: 'CAPI' },
      { cell: 'C13', value: 'Ahmedabad & Gandhinagar' },
      { cell: 'C14', value: 'Planned' },
      { cell: 'C15', value: 'CAPI' },
      { cell: 'D3', value: 'Achieved' },
      { cell: 'D4', value: 'CAPI' },
      { cell: 'D14', value: 'Achieved' },
      { cell: 'D15', value: 'CAPI' },
      { cell: 'E3', value: 'Pending' },
      { cell: 'E4', value: 'CAPI' },
      { cell: 'E14', value: 'Pending' },
      { cell: 'E15', value: 'CAPI' },
     
      
       ];
    let data2 = ['Ahmedabad & Gandhinagar','Surat','Total']
    cellsToStyleNew.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (data2.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = SpecialStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }else if (value == 'Achieved') {
        excelCell.font = headerStyle.font;
        excelCell.fill = achievedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Pending') {
        excelCell.font = headerStyle.font;
        excelCell.fill = pendingtyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = headerStyle.fill;
        excelCell.font = headerStyle.font;
      }

    });
  }


    let columnCValues = []
    // Define the values to fill in column D
   if (id?.id == "Maction") {
      columnCValues = [154 , 221 , 81 , 0 , 2 , 458 , 23, 19 , 14 , 14 , 23 , 12 , 5 , 110 , 568 ]
    }
    if (id?.id == "Kadence") {
      columnCValues = [51 , 74 , 27 , 0 , 1 , 153 , 8 , 6 , 5 , 5 , 8 , 4 , 2 , 37 , 189 ] 
    }
 
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndex = 0;
    let datatowrite=['Commercial','Residential','LTMD','Agriculture','HT','Total','Digital Interaction','All Application','Billing Complaints','All Other Complaints','Call center Interactions','Service Center Visits','KAM(HT)','Ahmedabad & Gandhinagar','Surat']
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
      const cellB = worksheet.getCell(`B${rowIndex}`);
      if (cellB.value && datatowrite.includes(cellB.value)) {
        const cellD = worksheet.getCell(`C${rowIndex}`);
        cellD.value = columnCValues[valueIndex++];
        if (rowIndex == 10 || rowIndex == 23 || rowIndex == 26 || rowIndex == 27) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        } 
        else {
          cellD.font = cellStyle.font;
          cellD.fill = plannedcellstyle.fill;

        }
 cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }

    }

    if (id?.id == "Maction") {

    let columnFValues = []
    // Define the values to fill in column D
   if (id?.id == "Maction") {
      columnFValues = [125 , 185 , 40 , 40 , 20 , 410 , 13, 11 , 8 , 8 , 13 , 7 , 3 , 63 ,473 ]
    }
 
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueFIndex = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
      const cellB = worksheet.getCell(`B${rowIndex}`);
      if (cellB.value && datatowrite.includes(cellB.value)) {
        const cellD = worksheet.getCell(`F${rowIndex}`);
        cellD.value = columnFValues[valueFIndex++];
        if (rowIndex == 10 || rowIndex == 23 || rowIndex == 26 || rowIndex == 27) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        } 
        else {
          cellD.font = cellStyle.font;
          cellD.fill = plannedcellstyle.fill;

        }
 cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }

    }

    let columnIValues = []
    // Define the values to fill in column D
   if (id?.id == "Maction") {
      columnIValues = [279 , 406 , 121 ,40 , 22 , 868 , 36 , 30 , 22 , 22 , 36 , 19 , 8 , 173 , 1041 ]
    }
 
  
   // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIIndex = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
      const cellB = worksheet.getCell(`B${rowIndex}`);
      if (cellB.value && datatowrite.includes(cellB.value)) {
        const cellD = worksheet.getCell(`I${rowIndex}`);
        cellD.value = columnIValues[valueIIndex++];
        if (rowIndex == 10 || rowIndex == 23 || rowIndex == 26 || rowIndex == 27) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        } 
        else {
          cellD.font = cellStyle.font;
          cellD.fill = plannedcellstyle.fill;

        }
 cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }

    }

    
  }

    const isCriterionMet = (answer, criterion) => {
        if (Array.isArray(criterion)) {
            return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
        } else {
            if (Array.isArray(answer)) {
                return answer.includes(criterion) ||
                    (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                    (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
            } else {
                return answer === criterion ||
                    (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                    (criterion === 'Other' && answer?.includes('Other:'));
            }
        }
    };
    
   
      
    
      // Updated countMatches function to incorporate the new logic
      const countMatches = (criteria) => {
        return generaldashboardData.filter(response =>
            criteria.every(criterion =>
                response.questions.some(q => {
                    if (isQuestionInCheckArray(q.question)) {
                        if (q.question === "Enter your details." && Array.isArray(q.answer)) {
                            // Extract City from Answer Array
                            const cityValue = extractCityFromDetails(q.answer);
                            return isCityMatched(cityValue, criterion); // Check city match
                        }
                        return isCriterionMet(q.answer, criterion);
                    }
                    return false;
                })
            )
        ).length;
    };
    const countMatchesGeneral = (criteria) => {
        return jouurneydashboardData.filter(response =>
            criteria.every(criterion =>
                response.questions.some(q => {
                    if (isQuestionInCheckArray(q.question)) {
                        if (q.question === "Enter your details." && Array.isArray(q.answer)) {
                            // Extract City from Answer Array
                            const cityValue = extractCityFromDetails(q.answer);
                            return isCityMatched(cityValue, criterion); // Check city match
                        }
                        return isCriterionMet(q.answer, criterion);
                    }
                    return false;
                })
            )
        ).length;
    };

    const extractCityFromDetails = (answerArray) => {
        // Extract the value for "City" from the answer array
        const cityEntry = answerArray.find(entry => entry.startsWith("City:"));
        return cityEntry ? cityEntry.split(":")[1].trim() : null;
    };
    
    const isCityMatched = (cityValue, criterion) => {
        console.log(cityValue,criterion)
        if (Array.isArray(criterion)) {
            // If criterion is an array, check if the city matches any of them
            return criterion.some(city => cityValue === city);
        }
        return cityValue === criterion; // Standard single city match
    };
    
      
      const criteriaMap = {
      

        5: ['Commercial', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        6: ['Residential', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        7: [['LTMD-Commercial','LTMD-Industrial'], ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        8: ['Agriculture', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        9: ['HT', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
      };
    
      Object.keys(criteriaMap).forEach(rowIndex => {
        const criteria = criteriaMap[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`D${rowIndex}`);
        cellH.value = count;
      
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      
      });

      const criteriaMapgeneral = {
      

        16: ['Digital Interaction', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        17: ['All Application', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        18: ['Billing Complaints', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        19: ['All Other Complaints', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        20: ['Call center Interactions', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        21: ['Service Center Visits', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
        22: ['KAM(HT)', ['Gandhinagar','GANDHINAGAR','Ahmedabad','AHMEDABAD']],
      };
    
      Object.keys(criteriaMapgeneral).forEach(rowIndex => {
        const criteria = criteriaMapgeneral[rowIndex];
        const count = countMatchesGeneral(criteria);
        const cellH = worksheet.getCell(`D${rowIndex}`);
        cellH.value = count;
      
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      
      });

      if (id?.id == "Maction") {
    //   for surat  

    const criteriaMapSurat = {
      

        5: ['Commercial', ['Surat','SURAT']],
        6: ['Residential', ['Surat','SURAT']],
        7: [['LTMD-Commercial','LTMD-Industrial'], ['Surat','SURAT']],
        8: ['Agriculture', ['Surat','SURAT']],
        9: ['HT', ['Surat','SURAT']],
      };
    
      Object.keys(criteriaMapSurat).forEach(rowIndex => {
        const criteria = criteriaMapSurat[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`G${rowIndex}`);
        cellH.value = count;
      
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      
      });
    



 


      const criteriaMapgeneralsurat = {
      

        16: ['Digital Interaction', ['Surat','SURAT']],
        17: ['All Application', ['Surat','SURAT']],
        18: ['Billing Complaints', ['Surat','SURAT']],
        19: ['All Other Complaints', ['Surat','SURAT']],
        20: ['Call center Interactions', ['Surat','SURAT']],
        21: ['Service Center Visits', ['Surat','SURAT']],
        22: ['KAM(HT)', ['Surat','SURAT']],
      };
    
      Object.keys(criteriaMapgeneralsurat).forEach(rowIndex => {
        const criteria = criteriaMapgeneral[rowIndex];
        const count = countMatchesGeneral(criteria);
        const cellH = worksheet.getCell(`G${rowIndex}`);
        cellH.value = count;
      
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      
      });
      // --------jaipur------- (For Credit Cards)
    
  

    }
    if (id?.id == "Maction") {
      // TOTAL  ACHIVED VALUES IN D 
      for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        const cellC = worksheet.getCell(`B${rowIndex}`);
        if (cellC.value && datatowrite.includes(cellC.value)) {
          const sum = ['D','G']
            .map(col => worksheet.getCell(`${col}${rowIndex}`).value || 0)
            .reduce((acc, value) => acc + value, 0);
  
          const cellE = worksheet.getCell(`J${rowIndex}`);
          cellE.value = sum;
          if (rowIndex == 10 || rowIndex == 23) {
            cellE.font = headerStyle.font
            cellE.fill = cellStyle.fill;
          }
          else {
            cellE.font = cellStyle.font;
  
            cellE.fill = achievedcellstyle.fill;
          }
  
          cellE.alignment = cellStyle.alignment;
          cellE.border = cellStyle.border;
        }
      }
    }



  // TOTAL PENDING VALUES

  if (id?.id == "Maction") {
  const columnsToSum = [
    { result: 'D10', from: 'D', rows: [5, 6, 7, 8, 9] },
    { result: 'G10', from: 'G', rows: [5, 6, 7, 8, 9] },
  ];
  
  columnsToSum.forEach(({ result, from, rows }) => {
    let total = 0;
    
    rows.forEach(rowIndex => {
      const cell = worksheet.getCell(`${from}${rowIndex}`);
      total += cell.value || 0;
    });
  
    const cellToFill = worksheet.getCell(result);
    cellToFill.value = total;
  
    // Apply styles
    if (result === 'D10' || result === 'G10') {
      cellToFill.font = headerStyle.font;
      cellToFill.fill = cellStyle.fill;
    } else {
      cellToFill.font = cellStyle.font;
      cellToFill.fill = pendingcellstyle.fill;
    }
    
    cellToFill.alignment = cellStyle.alignment;
    cellToFill.border = cellStyle.border;
  });

}
if (id?.id == "Kadence") {
  const columnsToSum = [
    { result: 'D10', from: 'D', rows: [5, 6, 7, 8, 9] },
    // { result: 'G10', from: 'G', rows: [5, 6, 7, 8, 9] },
  ];
  
  columnsToSum.forEach(({ result, from, rows }) => {
    let total = 0;
    
    rows.forEach(rowIndex => {
      const cell = worksheet.getCell(`${from}${rowIndex}`);
      total += cell.value || 0;
    });
  
    const cellToFill = worksheet.getCell(result);
    cellToFill.value = total;
  
    // Apply styles
    if (result === 'D10' || result === 'G10') {
      cellToFill.font = headerStyle.font;
      cellToFill.fill = cellStyle.fill;
    } else {
      cellToFill.font = cellStyle.font;
      cellToFill.fill = pendingcellstyle.fill;
    }
    
    cellToFill.alignment = cellStyle.alignment;
    cellToFill.border = cellStyle.border;
  });

}

  if (id?.id == "Maction") {

  const columnsToSum2 = [
    { result: 'D23', from: 'D', rows: [16, 17, 18, 19, 20 , 21 , 22] },
    { result: 'G23', from: 'G', rows: [16, 17, 18, 19, 20 , 21 , 22] },
  ];
  
  columnsToSum2.forEach(({ result, from, rows }) => {
    let total = 0;
    
    rows.forEach(rowIndex => {
      const cell = worksheet.getCell(`${from}${rowIndex}`);
      total += cell.value || 0;
    });
  
    const cellToFill = worksheet.getCell(result);
    cellToFill.value = total;
  
    // Apply styles
    if (result === 'D23' || result === 'G23') {
      cellToFill.font = headerStyle.font;
      cellToFill.fill = cellStyle.fill;
    } else {
      cellToFill.font = cellStyle.font;
      cellToFill.fill = pendingcellstyle.fill;
    }
    
    cellToFill.alignment = cellStyle.alignment;
    cellToFill.border = cellStyle.border;
  });
}

if (id?.id == "Kadence") {

  const columnsToSum2 = [
    { result: 'D23', from: 'D', rows: [16, 17, 18, 19, 20 , 21 , 22] },
    // { result: 'G23', from: 'G', rows: [16, 17, 18, 19, 20 , 21 , 22] },
  ];
  
  columnsToSum2.forEach(({ result, from, rows }) => {
    let total = 0;
    
    rows.forEach(rowIndex => {
      const cell = worksheet.getCell(`${from}${rowIndex}`);
      total += cell.value || 0;
    });
  
    const cellToFill = worksheet.getCell(result);
    cellToFill.value = total;
  
    // Apply styles
    if (result === 'D23' || result === 'G23') {
      cellToFill.font = headerStyle.font;
      cellToFill.fill = cellStyle.fill;
    } else {
      cellToFill.font = cellStyle.font;
      cellToFill.fill = pendingcellstyle.fill;
    }
    
    cellToFill.alignment = cellStyle.alignment;
    cellToFill.border = cellStyle.border;
  });
}
  
  if (id?.id == "Maction") {

      const columnsFinal = [
        { result: 'E', from: 'C', subtract: 'D' },
        { result: 'H', from: 'F', subtract: 'G' },
        { result: 'K', from: 'I', subtract: 'J' },
       
       
      ];
  
      columnsFinal.forEach(({ result, from, subtract }) => {
        for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
          const cellC = worksheet.getCell(`B${rowIndex}`);
          if (cellC.value  && datatowrite.includes(cellC.value)) {
            const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
            const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
            const cellToFill = worksheet.getCell(`${result}${rowIndex}`);
            const valueFrom = cellFrom.value || 0;
            const valueSubtract = cellSubtract.value || 0;
            cellToFill.value = valueFrom - valueSubtract;
            if (rowIndex == 10 || rowIndex == 23) {
              cellToFill.font = headerStyle.font
              cellToFill.fill = cellStyle.fill;
            }
            else {
              
              cellToFill.font = cellStyle.font;
  
              cellToFill.fill = pendingcellstyle.fill;
            }
            cellToFill.alignment = cellStyle.alignment;
            cellToFill.border = cellStyle.border;
          }
        }
      });

    }
    if (id?.id == "Kadence") {

      const columnsFinal = [
        { result: 'E', from: 'C', subtract: 'D' },
       
       
       
      ];
  
      columnsFinal.forEach(({ result, from, subtract }) => {
        for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
          const cellC = worksheet.getCell(`B${rowIndex}`);
          if (cellC.value  && datatowrite.includes(cellC.value)) {
            const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
            const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
            const cellToFill = worksheet.getCell(`${result}${rowIndex}`);
            const valueFrom = cellFrom.value || 0;
            const valueSubtract = cellSubtract.value || 0;
            cellToFill.value = valueFrom - valueSubtract;
            if (rowIndex == 10 || rowIndex == 23) {
              cellToFill.font = headerStyle.font
              cellToFill.fill = cellStyle.fill;
            }
            else {
              
              cellToFill.font = cellStyle.font;
  
              cellToFill.fill = pendingcellstyle.fill;
            }
            cellToFill.alignment = cellStyle.alignment;
            cellToFill.border = cellStyle.border;
          }
        }
      });

    }

    if (id?.id == "Maction") {

      const columnsToSum2final = [
        { result: 'C26', from: 'C', rows: [10, 23] },
        { result: 'D26', from: 'D', rows: [10, 23] },
        { result: 'E26', from: 'E', rows: [10, 23] },
        { result: 'F26', from: 'F', rows: [10, 23] },
        { result: 'G26', from: 'G', rows: [10, 23] },
        { result: 'H26', from: 'H', rows: [10, 23] },
        { result: 'I26', from: 'I', rows: [10, 23] },
        { result: 'J26', from: 'J', rows: [10, 23] },
        { result: 'K26', from: 'K', rows: [10, 23] },

      ];
      
      columnsToSum2final.forEach(({ result, from, rows }) => {
        let total = 0;
        
        rows.forEach(rowIndex => {
          const cell = worksheet.getCell(`${from}${rowIndex}`);
          total += cell.value || 0;
        });
      
        const cellToFill = worksheet.getCell(result);
        cellToFill.value = total;
      
        // Apply styles
        if (result === 'D23' || result === 'G23') {
          cellToFill.font = headerStyle.font;
          cellToFill.fill = cellStyle.fill;
        } else {
          cellToFill.font = cellStyle.font;
          cellToFill.fill = pendingcellstyle.fill;
        }
        
        cellToFill.alignment = cellStyle.alignment;
        cellToFill.border = cellStyle.border;
      });
  
    }

    if (id?.id == "Kadence") {

      const columnsToSum2final = [
        { result: 'C26', from: 'C', rows: [10, 23] },
        { result: 'D26', from: 'D', rows: [10, 23] },
        { result: 'E26', from: 'E', rows: [10, 23] },
       

      ];
      
      columnsToSum2final.forEach(({ result, from, rows }) => {
        let total = 0;
        
        rows.forEach(rowIndex => {
          const cell = worksheet.getCell(`${from}${rowIndex}`);
          total += cell.value || 0;
        });
      
        const cellToFill = worksheet.getCell(result);
        cellToFill.value = total;
      
        // Apply styles
        if (result === 'D23' || result === 'G23') {
          cellToFill.font = headerStyle.font;
          cellToFill.fill = cellStyle.fill;
        } else {
          cellToFill.font = cellStyle.font;
          cellToFill.fill = pendingcellstyle.fill;
        }
        
        cellToFill.alignment = cellStyle.alignment;
        cellToFill.border = cellStyle.border;
      });
  
    }
  


  if (id?.id == "Maction") {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'Maction.xlsx');
      setLoader(false);
    }

    if (id?.id == "Kadence") {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'KadenceQCC.xlsx');
      setLoader(false);
    }
   

  };
 


  return (
    <>
      {loader && <Loader />}
      <div className="excelcontainer">
        <div className="excelcard">
<label>Select Date </label>
        <input
                type="date"
                className='form-control'
                value={selectedDate}
                onChange={handleDateChange}
                style={{ marginBottom: '10px', padding: '5px' }}
            />
          
          {id?.id == "Maction" &&
            <> <label>Maction Qcc </label>
              <button className="btn btn-primary" onClick={() => handleDownloadRupay()}>Download</button>
            </>}
          <br />
          {id?.id == "Kadence" &&
    <> <label>Kadence Qcc</label>
      <button className="btn btn-primary" onClick={() => handleDownloadRupay()}>Download</button></>}
  <br />
        
        </div>

      </div>
    </>
  );
};

export default JourneysGeneral;


  
  
  